import React from "react";

export const OrderLineBlock = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={`relative min-w-[100px] min-h-[65px] w-[100px] h-[65px] rounded-md border border-solid border-borderGray bg-white text-gray-600 ${className}`}
      {...rest}
    >
      {props.children}
    </div>
  );
});
